import { Navigate } from 'react-router-dom';
import { Button } from '@/shared/components/ui/button';
import { isSimulatorOff, useSimulatorContent } from './simulatorApi';
import { useSimulatorFlag } from './simulatorFlag';
import { SimulatorEmailGate } from './SimulatorEmailGate';
import { Notice, SimulatorUnavailable } from './SimulatorNotice';
import { SimulatorReports } from './SimulatorReports';
import { SimulatorTakeFlow } from './SimulatorTakeFlow';

/**
 * Public longevity simulator for FPs in the bQuest training course, with or
 * without an account. Reached only through the course link; anyone else is
 * sent home so the page is never revealed. No auth guard: a logged-in visitor
 * gets the same anonymous flow.
 */
export const LongevitySimulatorPage = () => {
  const unlocked = useSimulatorFlag();
  if (!unlocked) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-background" data-testid="longevity-simulator">
      <header className="border-b border-gray-100 bg-[#0d5d4e] px-6 py-4">
        <span className="font-serif text-lg font-bold text-white">bQuest</span>
        <span className="ml-0.5 inline-block h-1.5 w-1.5 rounded-full bg-[#f3c66c] align-middle" />
      </header>
      <main className="px-4 py-10">
        <SimulatorContent />
      </main>
    </div>
  );
};

function SimulatorContent() {
  const { data, isLoading, error, refetch } = useSimulatorContent();

  if (isLoading) return <Notice>Loading…</Notice>;
  if (isSimulatorOff(error)) return <SimulatorUnavailable />;
  if (!data)
    return (
      <Notice>
        <p>Unable to load the simulator.</p>
        <Button type="button" variant="outline" className="mt-4" onClick={() => refetch()}>
          Try again
        </Button>
      </Notice>
    );

  return (
    <SimulatorTakeFlow
      content={data}
      renderFinished={({ draft, startOver, setGate, expire }) =>
        draft.gate === null ? (
          <SimulatorEmailGate
            onSubmitted={() => setGate('email')}
            onSkip={() => setGate('skipped')}
          />
        ) : (
          <SimulatorReports draft={draft} startOver={startOver} onStale={expire} />
        )
      }
    />
  );
}
